import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PopoverController } from '@ionic/angular';
import { OrganizacionService } from '@core/yalo/services';
import { ProfileAction, ProfileType } from './profile.types';
import { User } from '@core/yalo/user';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {
  public OrganizacionActiva;
  public Organizaciones = [];

  @Input() profileType: ProfileType;
  @Input() user!: User;
  @Input() actions: ProfileAction[] = [];

  constructor(
    private _router: Router,
    private organizacionService: OrganizacionService,
    private _popoverController: PopoverController
  ) {}

  ngOnInit() {
    if (this.profileType === 'empresarial') {
      this.organizacionService
        .obtenerListaOrganizaciones()
        .subscribe((data) => {
          this.Organizaciones = data;
          this.OrganizacionActiva =
            this.organizacionService.obtenerOrganizacionActiva();
        });
    }
  }

  irConfiguracion() {
    if (this.profileType === 'personal') {
      this._router.navigate(['/cuenta']);
    } else {
      this._router.navigate(['organizacion/configuracion']);
    }
    this._popoverController.dismiss();
  }

  setOrganization(CodOrganizacion) {
    if (CodOrganizacion.target.value === '') {
      return;
    }

    this.organizacionService.actualizarOrganizacion(
      CodOrganizacion.target.value
    );
  }
}
